// Frontend robot ID helper to mirror backend mapping logic.
// Keeps short IDs (e.g. '0004') and full serials (e.g. 'SMUR02SWP151124-0002') consistent.

const SHORT_TO_FULL = {
  '0001': 'SMUR02STD151124-0001',
  '0002': 'SMUR02STD151124-0002',
  '0003': 'SMUR02STD151124-0003',
  '0004': 'SMUR02SWP151124-0002' // SMUR-X
};

const FULL_TO_SHORT = Object.entries(SHORT_TO_FULL).reduce((acc, [shortId, fullId]) => {
  acc[fullId] = shortId;
  return acc;
}, {});

/**
 * Convert a full serial number to a short robot ID.
 * Falls back to suffix-based extraction when mapping is missing.
 */
export function getShortRobotId(fullId) {
  if (!fullId) return null;

  // Already a short ID
  if (/^\d{4}$/.test(fullId)) return fullId;

  if (FULL_TO_SHORT[fullId]) return FULL_TO_SHORT[fullId];

  // Fallback: take the last hyphen-separated segment (e.g. '...-0002' -> '0002')
  if (fullId.includes('-')) {
    const suffix = fullId.split('-').pop();
    if (/^\d{4}$/.test(suffix)) return suffix;
  }

  return null;
}

/**
 * Convert a short robot ID to a full serial number.
 * Falls back to a default STD-prefix format when mapping is missing.
 */
export function getFullRobotId(shortId) {
  if (!shortId) return null;

  // Normalize to 4 digits
  const normalized = String(shortId).padStart(4, '0');

  if (SHORT_TO_FULL[normalized]) return SHORT_TO_FULL[normalized];

  // Fallback: assume STD prefix if we don't know better
  return `SMUR02STD151124-${normalized}`;
}

export function getAllShortRobotIds() {
  return Object.keys(SHORT_TO_FULL);
}

export function getAllFullRobotIds() {
  return Object.values(SHORT_TO_FULL);
}


